export default "__VITE_ASSET__Bvr_vhFH__"